import { LabelService } from '../services';

const state = {
  locale: 'fr',
  header: '',
  home: '',
  login: '',
  register: '',
  profile: '',
  infos: '',
  addresses: '',
  pods: '',
  consumptions: '',
  indexes: '',
  data: '',
  admin: '',
  myAlerts: '',
  myEvents: '',
  mySpends: '',
  tutorials: '',
  tips: '',
  comparison: '',
  alerts: '',
  faq: ''
};

const actions = {
  getLabel({ dispatch, commit }, { view, force = false }) {
    if (!force && state[view] && state[view].locale === state.locale) {
      // Ne pas recharger les labels
      return;
    }

    LabelService.getLabel(view, state.locale).then(
      labels => {
        commit('setLabel', { view, labels });
      },
      () => {
        dispatch("alert/error", state.alerts.label || "Les labels n'ont pas pu être chargés", { root: true });
      }
    )
  },
  reloadLabel({ dispatch }, page = '') {
    if (page) {
      dispatch('getLabel', { view: page, force: true })
    } else {
      for (const [key, value] of Object.entries(state)) {
        if (typeof value === 'object') {
          dispatch('getLabel', { view: key })
        }
      }
    }
  },
  getLocale({ dispatch, commit }) {
    const locale = LabelService.getLocale();
    commit('setLocale', locale);
    dispatch('getLabel', { view: "alerts" })
  },
  switchLocale({ dispatch, commit }, locale) {
    localStorage.setItem('locale', locale);
    commit('setLocale', locale);
    dispatch('account/changeUserLang', locale, { root: true })
    dispatch('alert/clear', {}, { root: true })
    dispatch('reloadLabel')
  }
}

const mutations = {
  setLabel(state, { view, labels }) {
    state[view] = { ...labels, locale: state.locale };
  },
  setLocale(state, locale) {
    state.locale = locale
  }
}

const getters = {
  alerts: () => {
    return state.alerts
  },
  locale: () => {
    return state.locale
  }
}

export const labels = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}